import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { DateUtils } from "@grandvisionhq/utils";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { BOOK_APPOINTMENT_BY_ID } from "../../../../../queries/v3/queries/book-appointment-by-id.js";
import { fromBookAppointmentMutationToBookedAppointment } from "../../../adapters/v3/hooks/api/adapters/fromBookAppointmentMutationToBookedAppointment.js";
import { getStoredAffiliateId } from "../../../../../utils/v3/utils/affiliate-id-storage.js";
const TIMEOUT = 3e4;
const useBookAppointmentById = () => {
  const { locale } = useIntl();
  const [, { store, type, timeSlot, tryInStoreProductSkus }] = useAppointmentContext();
  const [query, queryState] = useMutation(
    BOOK_APPOINTMENT_BY_ID
  );
  const bookAppointment = React.useCallback(
    async (token, formData) => {
      if (!type || !store || !timeSlot) {
        throw new Error("Invalid application state, undefined type, store or timeslot");
      }
      try {
        await query({
          ...token ? {
            context: {
              forwardHeaders: {
                Authorization: `Bearer ${token}`
              },
              timeout: TIMEOUT
            }
          } : {
            context: {
              timeout: TIMEOUT
            }
          },
          variables: {
            data: {
              appointmentTypeId: type.id,
              globalStoreId: store.globalStoreId,
              startTime: DateUtils.toLocalDateTime(timeSlot.from),
              endTime: DateUtils.toLocalDateTime(timeSlot.until),
              affiliateId: getStoredAffiliateId(),
              productSkus: tryInStoreProductSkus,
              preferredLanguage: locale,
              ...formData
            }
          }
        });
      } catch (e) {
        console.error("Error while creating appointment", e);
      }
    },
    [type, store, timeSlot, query, tryInStoreProductSkus, locale]
  );
  const data = React.useMemo(
    () => ({
      appointment: fromBookAppointmentMutationToBookedAppointment(
        queryState.data?.bookAppointment.appointment
      ),
      failures: queryState.data?.bookAppointment.failures
    }),
    [queryState]
  );
  return React.useMemo(
    () => [bookAppointment, { ...queryState, data }],
    [bookAppointment, queryState, data]
  );
};
export {
  useBookAppointmentById as default,
  useBookAppointmentById
};
//# sourceMappingURL=use-book-appointment-by-id.js.map
